import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AllocateRecordOccupantPayrolls(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
    $employeeId: ID!
    $payrollIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                allocateOccupantPayrolls(
                  spaceRecordId: $spaceRecordId
                  employeeId: $employeeId
                  payrollIds: $payrollIds
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AllocateRecordOccupantPayrollsMutation,
  undefined,
  graphql.schema.AllocateRecordOccupantPayrollsMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
